import AmexSecurityCenterBrokerActivity from './AmexSecurityCenterBrokerActivity';

export default AmexSecurityCenterBrokerActivity;
